import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getIndustryRecentEpisode } from "../../../actions/industryofweek";
import { getEmployerRecentEpisode } from "../../../actions/employerspotlight";

import UserLogin from "../Innovators/UserLogin";
import IMEAltLogo from "./IMEAltLogo";

const LoggedOutNav = ({
  industryweek: { currentepisode },
  getIndustryRecentEpisode,
  employerweek,
  getEmployerRecentEpisode,
}) => {
  useEffect(() => {
    getIndustryRecentEpisode();
    getEmployerRecentEpisode();
  }, [getIndustryRecentEpisode, getEmployerRecentEpisode]);

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <UserLogin />
        <div className="center-nav">
          <div className="index-logo">
            <IMEAltLogo />
          </div>
          <div className="site-links-container">
            <div className="site-links">
              <ul className="links">
                <Link to="/">
                  <li className="link">
                    <i className="fas fa-home green mx-5"></i>Home
                  </li>
                </Link>
                <Link to={`/industryofweek/${currentepisode.industryname}`}>
                  <div className="link white background-dark-black">
                    <i className="fas fa-calendar-week green mx-5"></i>
                    Industry of the Week
                  </div>
                </Link>
                <Link to="/liveonime">
                  <li className="link">
                    <i className="fas fa-video green mx-5"></i>Live on ime
                  </li>
                </Link>
                <Link
                  to={`/employerspotlight/${employerweek.currentepisode.companyname}`}
                >
                  <div className="link white background-dark-black">
                    <i className="fa-solid fa-lightbulb  green mx-5"></i>
                    Employer Spotlight
                  </div>
                </Link>
                <Link to="/vrtours">
                  <li className="link">
                    <i className="fas fa-street-view green mx-5"></i>VR Tours
                  </li>
                </Link>
                <Link to="/trending">
                  <li className="link">
                    <i className="fas fa-fire green mx-5"></i>Trending
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="buttons">
          <Link to="/employers">
            <div className="action-items-index green">
              <div className="action-button-index green">
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Employers</p>
            </div>
          </Link>
          <Link to="/mentors">
            <div className="action-items-index green">
              <div className="action-button-index green">
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Mentors</p>
            </div>
          </Link>
        </div>
      </nav>
    </Fragment>
  );
};

LoggedOutNav.propTypes = {
  getIndustryRecentEpisode: PropTypes.func.isRequired,
  getEmployerRecentEpisode: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  industryweek: state.industryweek,
  employerweek: state.employerweek,
});

export default connect(mapStateToProps, {
  getIndustryRecentEpisode,
  getEmployerRecentEpisode,
})(LoggedOutNav);
